'use client';
import Box from '@mui/material/Box';
import appData from '@/lib/appData';
import { Button, Container, Paper, Stack, Typography } from '@mui/material';
import FacebookIcon from '@/components/icons/FacebookIcon';
import InstagramIcon from '@/components/icons/InstagramIcon';
import TikTokIcon from '../icons/TikTokIcon';
import YouTubeIcon from '../icons/YouTubeIcon';
import FadeIn from './FadeIn';

const socialIconsMap = {
  facebook: <FacebookIcon color='primary' />,
  instagram: <InstagramIcon color='primary' />,
  tiktok: <TikTokIcon color='primary' />,
  youtube: <YouTubeIcon color='primary' />,
}
const Footer: React.FC = () => {

  const { footer, socials } = appData;

  return (
    <>
      {socials.length > 0 && (
        <Box py={{ xs: 24, lg: 24 }}>
          <Container>
            <FadeIn>
              <Paper
                elevation={0}
                sx={{
                  px: { xs: 20, lg: 56 },
                  pt: { xs: 32, lg: 48 },
                  pb: { xs: 116, lg: 48 },
                  backgroundColor: 'primary.main',
                  color: 'white',
                  borderRadius: 6,
                  backgroundImage: {
                    xs: 'url(/assets/image/bg_social_mobile.png)',
                    lg: 'url(/assets/image/bg_social.png)'
                  },
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: { xs: 'top', lg: 'center' },
                }}
              >
                <Typography variant="displaySM" component="h2" color="inherit" mb={{ xs: 8, lg: 8 }}>Scopri i nostri contenuti</Typography>
                <Typography variant="headlineMDMedium" component="p" color="inherit">Seguici sui nostri canali social</Typography>

                <Stack
                  direction={{ xs: "column", lg: "row" }}
                  justifyContent="flex-start"
                  spacing={12}
                  mt={{ xs: 12, lg: 12 }}
                  flexWrap={'wrap'}
                  maxWidth={{xs: 130, lg: 'none'}}
                >
                  {socials.map((item) => (
                    <Button
                      key={item.icon}
                      size='medium'
                      color="primary"
                      href={item.link}
                      target='_blank'
                      rel="noopener noreferrer"
                      aria-label={`Visita il nostro profilo ${item.icon}`}
                      sx={{
                        backgroundColor: 'white',
                        px: 8,
                        '&:hover': { backgroundColor: 'grey.200' },
                      }}
                    >
                      {item.icon}
                      {socialIconsMap[item.icon as keyof typeof socialIconsMap]}
                    </Button>
                  ))}
                </Stack>
              </Paper>
            </FadeIn>
          </Container>
        </Box>
      )}
      <Box component="footer" bgcolor="grey.900" color="white" py={{ xs: 12, lg: 8 }}>
        <Container>
          <Stack direction={{ xs: "column", lg: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", lg: "center" }}>
            <Typography variant="captionLGRegular">{footer.copyright}</Typography>

            <Stack direction="row" flexWrap={'wrap'} gap={12} rowGap={6} mt={{ xs: 16, lg: 0 }}>
              {footer.links.map((item) => (
                <Typography key={item.label} variant="bodySMSemibold" sx={{ textDecoration: 'underline', textUnderlineOffset: '4px' }}>
                  <a href={item.link} target='_blank' rel="noopener noreferrer">{item.label}</a>
                </Typography>
              ))}
            </Stack>
          </Stack>
        </Container>
      </Box>
    </>
  );
}

export default Footer;